import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const rootElement = document.documentElement;
rootElement.classList.add('icons-loading');

const revealIcons = () => rootElement.classList.remove('icons-loading');

if (document.fonts && document.fonts.load) {
  document.fonts
    .load('1em "Material Symbols Outlined"')
    .then(revealIcons)
    .catch(revealIcons);
} else {
  window.addEventListener('load', revealIcons, { once: true });
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
